module.exports = __webpack_public_path__ + "static/media/aero4.78a9f316.jpg";